import { Action, createAction, props } from '@ngrx/store';
import { Flight } from 'src/app/models/booking.models';

const enum FlightActionTypes {
  search = '[flight] SEARCH',
  lowFareSearch = '[flight] LOW_FARE_SEARCH',
  setSearchResult = '[flight] SET_SEARCH_RESULT',
  setLowFareSearchResult = '[flight] SET_LOW_FARE_SEARCH_RESULT',
  clearSearchResult = '[flight] CLEAR_SEARCH_RESULT',
  validateSelections = '[flight] VALIDATE_SELECTIONS',
}

export const flightSearch = createAction(
  FlightActionTypes.search,
  props<{ search: string }>(),
);

export const flightLowFareSearch = createAction(
  FlightActionTypes.lowFareSearch,
  props<{ payload: string; next: Action[] }>(),
);

export const flightSetSearchResult = createAction(
  FlightActionTypes.setSearchResult,
  props<{ search: string; data: Flight }>(),
);

export const flightSetLowFareSearchResult = createAction(
  FlightActionTypes.setLowFareSearchResult,
  props<{ search: string; data: Flight }>(),
);

export const flightClearSearchResults = createAction(
  FlightActionTypes.clearSearchResult,
);

export const flightValidateSelections = createAction(
  FlightActionTypes.validateSelections,
);
